// Airport
import a from "./Gellery/Airport/airport (1).jpg";
import a1 from "./Gellery/Airport/airport (2).jpg";

// Ambuluwawa
import d from "./Gellery/Ambuluwawa/g26.jpg";
import e from "./Gellery/Ambuluwawa/g25.jpg";

// Bawa (1-67, skip 6)
import b from "./Gellery/Bawa/bawa (1).jpeg";
import b1 from "./Gellery/Bawa/bawa (2).jpeg";
import b2 from "./Gellery/Bawa/bawa (3).jpeg";
import b3 from "./Gellery/Bawa/bawa (4).jpeg";
import b4 from "./Gellery/Bawa/bawa (5).jpeg";
import b5 from "./Gellery/Bawa/bawa (6).jpeg";
import b7 from "./Gellery/Bawa/bawa (7).jpeg";
import b8 from "./Gellery/Bawa/bawa (8).jpeg";
import b9 from "./Gellery/Bawa/bawa (9).jpeg";
import b10 from "./Gellery/Bawa/bawa (10).jpeg";
import b11 from "./Gellery/Bawa/bawa (11).jpeg";
import b12 from "./Gellery/Bawa/bawa (12).jpeg";
import b13 from "./Gellery/Bawa/bawa (13).jpeg";
import b14 from "./Gellery/Bawa/bawa (14).jpeg";
import b15 from "./Gellery/Bawa/bawa (15).jpeg";
import b16 from "./Gellery/Bawa/bawa (16).jpeg";
import b17 from "./Gellery/Bawa/bawa (17).jpeg";
import b18 from "./Gellery/Bawa/bawa (18).jpeg";
import b19 from "./Gellery/Bawa/bawa (19).jpeg";
import b20 from "./Gellery/Bawa/bawa (20).jpeg";
import b21 from "./Gellery/Bawa/bawa (21).jpeg";
import b22 from "./Gellery/Bawa/bawa (22).jpeg";
import b23 from "./Gellery/Bawa/bawa (23).jpeg";
import b24 from "./Gellery/Bawa/bawa (24).jpeg";
import b25 from "./Gellery/Bawa/bawa (25).jpeg";
import b26 from "./Gellery/Bawa/bawa (26).jpeg";
import b27 from "./Gellery/Bawa/bawa (27).jpeg";
import b28 from "./Gellery/Bawa/bawa (28).jpeg";
import b29 from "./Gellery/Bawa/bawa (29).jpeg";
import b30 from "./Gellery/Bawa/bawa (30).jpeg";
import b31 from "./Gellery/Bawa/bawa (31).jpeg";
import b32 from "./Gellery/Bawa/bawa (32).jpeg";
import b33 from "./Gellery/Bawa/bawa (33).jpeg";
import b34 from "./Gellery/Bawa/bawa (34).jpeg";
import b35 from "./Gellery/Bawa/bawa (35).jpeg";
import b36 from "./Gellery/Bawa/bawa (36).jpeg";
import b37 from "./Gellery/Bawa/bawa (37).jpeg";
import b38 from "./Gellery/Bawa/bawa (38).jpeg";
import b39 from "./Gellery/Bawa/bawa (39).jpeg";
import b40 from "./Gellery/Bawa/bawa (40).jpeg";
import b41 from "./Gellery/Bawa/bawa (41).jpeg";
import b42 from "./Gellery/Bawa/bawa (42).jpeg";
import b43 from "./Gellery/Bawa/bawa (43).jpeg";
import b44 from "./Gellery/Bawa/bawa (44).jpeg";
import b45 from "./Gellery/Bawa/bawa (45).jpeg";
import b46 from "./Gellery/Bawa/bawa (46).jpeg";
import b47 from "./Gellery/Bawa/bawa (47).jpeg";
import b48 from "./Gellery/Bawa/bawa (48).jpeg";
import b49 from "./Gellery/Bawa/bawa (49).jpeg";
import b50 from "./Gellery/Bawa/bawa (50).jpeg";
import b51 from "./Gellery/Bawa/bawa (51).jpeg";
import b52 from "./Gellery/Bawa/bawa (52).jpeg";
import b53 from "./Gellery/Bawa/bawa (53).jpeg";
import b54 from "./Gellery/Bawa/bawa (54).jpeg";
import b55 from "./Gellery/Bawa/bawa (55).jpeg";
import b56 from "./Gellery/Bawa/bawa (56).jpeg";
import b57 from "./Gellery/Bawa/bawa (57).jpeg";
import b58 from "./Gellery/Bawa/bawa (58).jpeg";
import b59 from "./Gellery/Bawa/bawa (59).jpeg";
import b60 from "./Gellery/Bawa/bawa (60).jpeg";
import b61 from "./Gellery/Bawa/bawa (61).jpeg";
import b62 from "./Gellery/Bawa/bawa (62).jpeg";
import b63 from "./Gellery/Bawa/bawa (63).jpeg";
import b64 from "./Gellery/Bawa/bawa (64).jpeg";
import b65 from "./Gellery/Bawa/bawa (65).jpeg";
import b66 from "./Gellery/Bawa/bawa (66).jpeg";
import b67 from "./Gellery/Bawa/bawa (67).jpeg";
import b68 from "./Gellery/Bawa/up (1).jpg";
import b69 from "./Gellery/Bawa/up (2).jpg";
import b70 from "./Gellery/Bawa/up (3).jpg";
import b71 from "./Gellery/Bawa/up (4).jpg";
import b72 from "./Gellery/Bawa/up (5).jpg";


// Brif (1-67, skip 6)
import c1 from "./Gellery/brif/brif (1).jpeg";
import c2 from "./Gellery/brif/brif (2).jpeg";
import c3 from "./Gellery/brif/brif (3).jpeg";
import c4 from "./Gellery/brif/brif (4).jpeg";
import c5 from "./Gellery/brif/brif (5).jpeg";
import c6 from "./Gellery/brif/brif (6).jpeg";
import c7 from "./Gellery/brif/brif (7).jpeg";
import c8 from "./Gellery/brif/brif (8).jpeg";
import c9 from "./Gellery/brif/brif (9).jpeg";
import c10 from "./Gellery/brif/brif (10).jpeg";
import c11 from "./Gellery/brif/brif (11).jpeg";
import c12 from "./Gellery/brif/brif (12).jpeg";
import c13 from "./Gellery/brif/brif (13).jpeg";
import c14 from "./Gellery/brif/brif (14).jpeg";
import c15 from "./Gellery/brif/brif (15).jpeg";
import c16 from "./Gellery/brif/brif (16).jpeg";
import c17 from "./Gellery/brif/brif (17).jpeg";
import c18 from "./Gellery/brif/brif (18).jpeg";
import c19 from "./Gellery/brif/brif (19).jpeg";
import c20 from "./Gellery/brif/brif (20).jpeg";
import c21 from "./Gellery/brif/brif (21).jpeg";
import c22 from "./Gellery/brif/brif (22).jpeg";
import c23 from "./Gellery/brif/brif (23).jpeg";
import c24 from "./Gellery/brif/brif (24).jpeg";
import c25 from "./Gellery/brif/brif (25).jpeg";

//ella
import d1 from "./Gellery/Ella/ella (1).jpeg";
import dd1 from "./Gellery/Ella/ella (1).jpg";
import d2 from "./Gellery/Ella/ella (2).jpeg";
import dd2 from "./Gellery/Ella/ella (2).jpg";
import d3 from "./Gellery/Ella/ella (3).jpeg";
import dd3 from "./Gellery/Ella/ella (3).jpg";
import d4 from "./Gellery/Ella/ella (4).jpeg";
import dd4 from "./Gellery/Ella/ella (4).jpg";
import d5 from "./Gellery/Ella/ella (5).jpeg";
import d8 from "./Gellery/Ella/ella (5).jpg";
import d6 from "./Gellery/Ella/ella (6).jpg";
import d7 from "./Gellery/Ella/ella (7).jpg";

//galle

import ee from "./Gellery/Galle/galle (1).jpeg";
import e1 from "./Gellery/Galle/galle (1).jpg";
import e2 from "./Gellery/Galle/galle (2).jpg";
import e3 from "./Gellery/Galle/galle (3).jpg";
import e4 from "./Gellery/Galle/galle (4).jpg";
import e5 from "./Gellery/Galle/galle (5).jpg";
import e6 from "./Gellery/Galle/galle (6).jpg";
import e7 from "./Gellery/Galle/galle (6).jpeg";
import e8 from "./Gellery/Galle/galle (5).jpeg";
import e9 from "./Gellery/Galle/galle (7).jpeg";
import e10 from "./Gellery/Galle/galle (7).jpg";
import e11 from "./Gellery/Galle/galle (8).jpg";
import e13 from "./Gellery/Galle/galle (12).jpeg";
import e14 from "./Gellery/Galle/galle (13).jpeg";
import e15 from "./Gellery/Galle/galle (14).jpeg";
import e16 from "./Gellery/Galle/galle (15).jpeg";
import e17 from "./Gellery/Galle/galle (16).jpeg";
import e18 from "./Gellery/Galle/galle (17).jpeg";
import e12 from "./Gellery/Galle/galle (18).jpeg";

import f from "./Gellery/gem/gem.jpeg"

import g from "./Gellery/god temple/god (1).jpeg";
import g1 from "./Gellery/god temple/god (1).jpg";
import g2 from "./Gellery/god temple/god (2).jpeg";
import g3 from "./Gellery/god temple/god (3).jpeg";
import g4 from "./Gellery/god temple/god (4).jpeg";
import g5 from "./Gellery/god temple/god (5).jpeg";
import g6 from "./Gellery/god temple/god (6).jpeg";

// sigiri & dambulla


import h from "./Gellery/Sigiri_dambulla/sigiri (1).jpeg";
import h1 from "./Gellery/Sigiri_dambulla/sigiri (1).jpg";
import h2 from "./Gellery/Sigiri_dambulla/sigiri (2).jpeg";
import h3 from "./Gellery/Sigiri_dambulla/sigiri (2).jpg";
import h4 from "./Gellery/Sigiri_dambulla/sigiri (3).jpg";
import h5 from "./Gellery/Sigiri_dambulla/sigiri (3).jpeg";
import h6 from "./Gellery/Sigiri_dambulla/sigiri (4).jpeg";
import h7 from "./Gellery/Sigiri_dambulla/sigiri (4).jpg";
import h8 from "./Gellery/Sigiri_dambulla/sigiri (5).jpg";
import h9 from "./Gellery/Sigiri_dambulla/sigiri (5).jpeg";
import h10 from "./Gellery/Sigiri_dambulla/sigiri (6).jpeg";
import h11 from "./Gellery/Sigiri_dambulla/sigiri (6).jpg";
import h12 from "./Gellery/Sigiri_dambulla/sigiri (7).jpeg";
import h13 from "./Gellery/Sigiri_dambulla/sigiri (8).jpeg";
import h14 from "./Gellery/Sigiri_dambulla/sigiri (9).jpeg";
import h15 from "./Gellery/Sigiri_dambulla/sigiri (10).jpeg";
import h16 from "./Gellery/Sigiri_dambulla/sigiri (11).jpeg";
import h17 from "./Gellery/Sigiri_dambulla/sigiri (12).jpeg";
import h18 from "./Gellery/Sigiri_dambulla/sigiri (13).jpeg";
import h19 from "./Gellery/Sigiri_dambulla/sigiri (14).jpeg";
import h20 from "./Gellery/Sigiri_dambulla/sigiri (15).jpeg";
import h21 from "./Gellery/Sigiri_dambulla/sigiri (16).jpeg";
import h22 from "./Gellery/Sigiri_dambulla/sigiri (17).jpeg";
import h23 from "./Gellery/Sigiri_dambulla/sigiri (18).jpeg";
import h24 from "./Gellery/Sigiri_dambulla/sigiri (19).jpeg";
import h25 from "./Gellery/Sigiri_dambulla/sigiri (20).jpeg";
import h26 from "./Gellery/Sigiri_dambulla/sigiri (21).jpeg";
import h27 from "./Gellery/Sigiri_dambulla/sigiri (22).jpeg";
import h28 from "./Gellery/Sigiri_dambulla/sigiri (23).jpeg";
import h29 from "./Gellery/Sigiri_dambulla/sigiri (24).jpeg";
import h30 from "./Gellery/Sigiri_dambulla/sigiri (25).jpeg";
import h31 from "./Gellery/Sigiri_dambulla/sigiri (26).jpeg";
import h32 from "./Gellery/Sigiri_dambulla/sigiri (27).jpeg";
import h33 from "./Gellery/Sigiri_dambulla/sigiri (28).jpeg";
import h34 from "./Gellery/Sigiri_dambulla/sigiri (29).jpeg";
import h35 from "./Gellery/Sigiri_dambulla/sigiri (30).jpeg";
import h36 from "./Gellery/Sigiri_dambulla/sigiri (31).jpeg";
import h37 from "./Gellery/Sigiri_dambulla/sigiri (32).jpeg";

// shiva

import i from "./Gellery/shiva/shiva.jpeg"
import i1 from "./Gellery/shiva/shiva.jpg"

// Kandevihre

import j from "./Gellery/kandevihara/kande (3).jpg"
import j1 from "./Gellery/kandevihara/kande (1).jpg"
import j2 from "./Gellery/kandevihara/kande (1).jpeg"
import j3 from "./Gellery/kandevihara/kande (2).jpg"

// kandy

import hh from "./Gellery/kandy/kandy (1).jpg"
import hh1 from "./Gellery/kandy/kandy (2).jpg"

//SPA cylone

import k from "./Gellery/spa/spa.jpeg"

//pinnawala
import l from "./Gellery/Pinnawala/pinnawala.jpeg"

// Moonstone Mine
import m from "./Gellery/moonstone_mine/moonstone.jpeg"
import m1 from "./Gellery/moonstone_mine/moonstone.jpg"

// tea land and waterfall
import p from "./Gellery/Tea land and waterfall/tealand (1).jpeg"
import p1 from "./Gellery/Tea land and waterfall/tealand (1).jpg"
import p2 from "./Gellery/Tea land and waterfall/tealand (2).jpeg"
import p3 from "./Gellery/Tea land and waterfall/tealand (2).jpg"
import p4 from "./Gellery/Tea land and waterfall/tealand (3).jpeg"
import p5 from "./Gellery/Tea land and waterfall/tealand (3).jpg"
import p6 from "./Gellery/Tea land and waterfall/tealand (4).jpeg"
import p7 from "./Gellery/Tea land and waterfall/tealand (4).jpg"
import p8 from "./Gellery/Tea land and waterfall/tealand (5).jpg"
import p9 from "./Gellery/Tea land and waterfall/tealand (6).jpg"
import p10 from "./Gellery/Tea land and waterfall/tealand (7).jpg"
import p11 from "./Gellery/Tea land and waterfall/tealand (8).jpg"
import p12 from "./Gellery/Tea land and waterfall/tealand (9).jpg"

//karandeniya

import q from "./Gellery/Karandeniya/karandeni (1).jpeg"
import q1 from "./Gellery/Karandeniya/karandeni (1).jpg"
import q2 from "./Gellery/Karandeniya/karandeni (2).jpg"
import q3 from "./Gellery/Karandeniya/karandeni (3).jpg"
import q4 from "./Gellery/Karandeniya/karandeni (4).jpeg"
import q5 from "./Gellery/Karandeniya/karandeni (4).jpg"
import q6 from "./Gellery/Karandeniya/karandeni (5).jpeg"
import q7 from "./Gellery/Karandeniya/karandeni (5).jpg"
import q8 from "./Gellery/Karandeniya/karandeni (6).jpg"
import q9 from "./Gellery/Karandeniya/karandeni (7).jpg"
import q10 from "./Gellery/Karandeniya/karandeni (8).jpg"
import q11 from "./Gellery/Karandeniya/karandeni (14).jpeg"
import q12 from "./Gellery/Karandeniya/karandeni (16).jpeg"
import q13 from "./Gellery/Karandeniya/karandeni (17).jpeg"
import q14 from "./Gellery/Karandeniya/karandeni (18).jpeg"
import q15 from "./Gellery/Karandeniya/karandeni (19).jpeg"
import q16 from "./Gellery/Karandeniya/karandeni (20).jpeg"
import q17 from "./Gellery/Karandeniya/karandeni (21).jpeg"
import q18 from "./Gellery/Karandeniya/karandeni (22).jpeg"
import q19 from "./Gellery/Karandeniya/karandeni (23).jpeg"
import q20 from "./Gellery/Karandeniya/karandeni (24).jpeg"
import q21 from "./Gellery/Karandeniya/karandeni (25).jpeg"

//Honey Beach
import r57 from "./Gellery/Honey_beach/honey (1).jpeg"
import r1 from "./Gellery/Honey_beach/honey (1).jpg"
import r2 from "./Gellery/Honey_beach/honey (2).jpeg"
import r3 from "./Gellery/Honey_beach/honey (2).jpg"
import r4 from "./Gellery/Honey_beach/honey (3).jpg"
import r5 from "./Gellery/Honey_beach/honey (3).jpeg"
import r6 from "./Gellery/Honey_beach/honey (4).jpeg"
import r7 from "./Gellery/Honey_beach/honey (4).jpg"
import r8 from "./Gellery/Honey_beach/honey (5).jpeg"
import r9 from "./Gellery/Honey_beach/honey (5).jpg"
import r10 from "./Gellery/Honey_beach/honey (6).jpeg"
import r11 from "./Gellery/Honey_beach/honey (6).jpg"
import r12 from "./Gellery/Honey_beach/honey (7).jpeg"
import r13 from "./Gellery/Honey_beach/honey (8).jpeg"
import r14 from "./Gellery/Honey_beach/honey (9).jpeg"
import r15 from "./Gellery/Honey_beach/honey (10).jpeg"
import r16 from "./Gellery/Honey_beach/honey (11).jpeg"
import r17 from "./Gellery/Honey_beach/honey (12).jpeg"
import r18 from "./Gellery/Honey_beach/honey (13).jpeg"
import r19 from "./Gellery/Honey_beach/honey (14).jpeg"
import r20 from "./Gellery/Honey_beach/honey (15).jpeg"
import r21 from "./Gellery/Honey_beach/honey (16).jpeg"
import r22 from "./Gellery/Honey_beach/honey (17).jpeg"
import r23 from "./Gellery/Honey_beach/honey (18).jpeg"
import r24 from "./Gellery/Honey_beach/honey (19).jpeg"
import r25 from "./Gellery/Honey_beach/honey (20).jpeg"
import r26 from "./Gellery/Honey_beach/honey (21).jpeg"
import r27 from "./Gellery/Honey_beach/honey (22).jpeg"
import r28 from "./Gellery/Honey_beach/honey (23).jpeg"
import r29 from "./Gellery/Honey_beach/honey (24).jpeg"
import r30 from "./Gellery/Honey_beach/honey (25).jpeg"
import r31 from "./Gellery/Honey_beach/honey (26).jpeg"
import r32 from "./Gellery/Honey_beach/honey (27).jpeg"
import r33 from "./Gellery/Honey_beach/honey (28).jpeg"
import r34 from "./Gellery/Honey_beach/honey (29).jpeg"
import r35 from "./Gellery/Honey_beach/honey (30).jpeg"
import r36 from "./Gellery/Honey_beach/honey (31).jpeg"
import r37 from "./Gellery/Honey_beach/honey (32).jpeg"
import r38 from "./Gellery/Honey_beach/honey (33).jpeg"
import r39 from "./Gellery/Honey_beach/honey (34).jpeg"
import r40 from "./Gellery/Honey_beach/honey (35).jpeg"
import r41 from "./Gellery/Honey_beach/honey (36).jpeg"
import r42 from "./Gellery/Honey_beach/honey (37).jpeg"
import r52 from "./Gellery/Honey_beach/honey (38).jpeg"
import r53 from "./Gellery/Honey_beach/honey (39).jpeg"
import r54 from "./Gellery/Honey_beach/honey (40).jpeg"
import r55 from "./Gellery/Honey_beach/honey (41).jpeg"
import r56 from "./Gellery/Honey_beach/honey (42).jpeg"
import r43 from "./Gellery/Honey_beach/honey (43).jpeg";
import r44 from "./Gellery/Honey_beach/honey (44).jpeg";
import r45 from "./Gellery/Honey_beach/honey (45).jpeg";
import r46 from "./Gellery/Honey_beach/honey (46).jpeg";
import r47 from "./Gellery/Honey_beach/honey (47).jpeg";
import r48 from "./Gellery/Honey_beach/honey (48).jpeg";
import r49 from "./Gellery/Honey_beach/honey (49).jpeg";
import r50 from "./Gellery/Honey_beach/honey (50).jpeg";
import r51 from "./Gellery/Honey_beach/honey (51).jpeg";


//hikkduw Beach
import s from "./Gellery/Hikkaduwa/Hikkaduwa (1).jpeg"
import s1 from "./Gellery/Hikkaduwa/Hikkaduwa (1).jpg"
import s2 from "./Gellery/Hikkaduwa/Hikkaduwa (2).jpeg"
import s3 from "./Gellery/Hikkaduwa/Hikkaduwa (3).jpeg"

//Madu lagoun
import t1 from "./Gellery/Madu lagum tour/madu (1).jpeg";
import t2 from "./Gellery/Madu lagum tour/madu (2).jpeg";
import t3 from "./Gellery/Madu lagum tour/madu (3).jpeg";
import t5 from "./Gellery/Madu lagum tour/madu (4).jpeg";
import t4 from "./Gellery/Madu lagum tour/madu (5).jpeg";
import t6 from "./Gellery/Madu lagum tour/madu (6).jpeg";
import t7 from "./Gellery/Madu lagum tour/madu (7).jpeg";
import t8 from "./Gellery/Madu lagum tour/madu (8).jpeg";
import t9 from "./Gellery/Madu lagum tour/madu (9).jpeg";
import t10 from "./Gellery/Madu lagum tour/madu (10).jpeg";
import t11 from "./Gellery/Madu lagum tour/madu (11).jpeg";
import t12 from "./Gellery/Madu lagum tour/madu (12).jpeg";
import t13 from "./Gellery/Madu lagum tour/madu (13).jpeg";
import t14 from "./Gellery/Madu lagum tour/madu (14).jpeg";
import t15 from "./Gellery/Madu lagum tour/madu (15).jpeg";
import t16 from "./Gellery/Madu lagum tour/madu (16).jpeg";
import t18 from "./Gellery/Madu lagum tour/madu (18).jpeg";
import t19 from "./Gellery/Madu lagum tour/madu (19).jpeg";
import t20 from "./Gellery/Madu lagum tour/madu (20).jpeg";
import t21 from "./Gellery/Madu lagum tour/madu (21).jpeg";
import t22 from "./Gellery/Madu lagum tour/madu (22).jpeg";
import t24 from "./Gellery/Madu lagum tour/madu (24).jpeg";
import t25 from "./Gellery/Madu lagum tour/madu (25).jpeg";
import t26 from "./Gellery/Madu lagum tour/madu (26).jpeg";
import t27 from "./Gellery/Madu lagum tour/madu (27).jpeg";
import t28 from "./Gellery/Madu lagum tour/madu (28).jpeg";
import t29 from "./Gellery/Madu lagum tour/madu (29).jpeg";
import t30 from "./Gellery/Madu lagum tour/madu (30).jpeg";
import t31 from "./Gellery/Madu lagum tour/madu (31).jpeg";
import t32 from "./Gellery/Madu lagum tour/madu (32).jpeg";
import t33 from "./Gellery/Madu lagum tour/madu (33).jpeg";
import t34 from "./Gellery/Madu lagum tour/madu (34).jpeg";
import t35 from "./Gellery/Madu lagum tour/madu (35).jpeg";
import t36 from "./Gellery/Madu lagum tour/madu (36).jpeg";
import t37 from "./Gellery/Madu lagum tour/madu (37).jpeg";
import t38 from "./Gellery/Madu lagum tour/madu (38).jpeg";
import t39 from "./Gellery/Madu lagum tour/madu (39).jpeg";
import t40 from "./Gellery/Madu lagum tour/madu (40).jpeg";
import t41 from "./Gellery/Madu lagum tour/madu (41).jpeg";
import t42 from "./Gellery/Madu lagum tour/madu (42).jpeg";
import t43 from "./Gellery/Madu lagum tour/madu (43).jpeg";
import t44 from "./Gellery/Madu lagum tour/madu (44).jpeg";
import t45 from "./Gellery/Madu lagum tour/madu (45).jpeg";
import t46 from "./Gellery/Madu lagum tour/madu (46).jpeg";
import t47 from "./Gellery/Madu lagum tour/madu (47).jpeg";
import t48 from "./Gellery/Madu lagum tour/madu (48).jpeg";
import t49 from "./Gellery/Madu lagum tour/madu (49).jpeg";
import t50 from "./Gellery/Madu lagum tour/madu (50).jpeg";
import t51 from "./Gellery/Madu lagum tour/madu (51).jpeg";
import t52 from "./Gellery/Madu lagum tour/madu (52).jpeg";
import t53 from "./Gellery/Madu lagum tour/madu (53).jpeg";
import t54 from "./Gellery/Madu lagum tour/madu (54).jpeg";
import t55 from "./Gellery/Madu lagum tour/madu (55).jpeg";
import t56 from "./Gellery/Madu lagum tour/madu (56).jpeg";
import t57 from "./Gellery/Madu lagum tour/madu (57).jpeg";
import t58 from "./Gellery/Madu lagum tour/madu (58).jpeg";
import t59 from "./Gellery/Madu lagum tour/madu (59).jpeg";
import t60 from "./Gellery/Madu lagum tour/madu (60).jpeg";
import t61 from "./Gellery/Madu lagum tour/madu (61).jpeg";
import t62 from "./Gellery/Madu lagum tour/madu (62).jpeg";
import t63 from "./Gellery/Madu lagum tour/madu (63).jpeg";
import t64 from "./Gellery/Madu lagum tour/madu (64).jpeg";
import t65 from "./Gellery/Madu lagum tour/madu (65).jpeg";
import t66 from "./Gellery/Madu lagum tour/madu (66).jpeg";
import t67 from "./Gellery/Madu lagum tour/madu (67).jpeg";
import t68 from "./Gellery/Madu lagum tour/madu (68).jpeg";
import t69 from "./Gellery/Madu lagum tour/madu (69).jpeg";
import t70 from "./Gellery/Madu lagum tour/madu (70).jpeg";
import t71 from "./Gellery/Madu lagum tour/madu (71).jpeg";
import t72 from "./Gellery/Madu lagum tour/madu (72).jpeg";
import t73 from "./Gellery/Madu lagum tour/madu (73).jpeg";
import t74 from "./Gellery/Madu lagum tour/madu (74).jpeg";
import t75 from "./Gellery/Madu lagum tour/madu (75).jpeg";
import t76 from "./Gellery/Madu lagum tour/madu (1).jpg";
import t77 from "./Gellery/Madu lagum tour/madu (2).jpg";
import t78 from "./Gellery/Madu lagum tour/madu (3).jpg";
import t79 from "./Gellery/Madu lagum tour/madu (4).jpg";
import t81 from "./Gellery/Madu lagum tour/madu (6).jpg";
import t82 from "./Gellery/Madu lagum tour/madu (7).jpg";
import t83 from "./Gellery/Madu lagum tour/madu (8).jpg";
import t84 from "./Gellery/Madu lagum tour/madu (9).jpg";
import t85 from "./Gellery/Madu lagum tour/madu (10).jpg";
import t86 from "./Gellery/Madu lagum tour/madu (11).jpg";
import t87 from "./Gellery/Madu lagum tour/madu (12).jpg";
import t88 from "./Gellery/Madu lagum tour/madu (13).jpg";
import t89 from "./Gellery/Madu lagum tour/madu (14).jpg";
import t90 from "./Gellery/Madu lagum tour/madu (15).jpg";
import t91 from "./Gellery/Madu lagum tour/madu (16).jpg";
import t92 from "./Gellery/Madu lagum tour/madu (17).jpg";
import t93 from "./Gellery/Madu lagum tour/madu (18).jpg";
import t94 from "./Gellery/Madu lagum tour/madu (19).jpg";
import t95 from "./Gellery/Madu lagum tour/madu (20).jpg";
import t96 from "./Gellery/Madu lagum tour/madu (21).jpg";
import t97 from "./Gellery/Madu lagum tour/madu (22).jpg";

//Turtle

import u1 from "./Gellery/turtle_Farm/turtle (1).jpeg"
import u2 from "./Gellery/turtle_Farm/turtle (1).jpg"
import u3 from "./Gellery/turtle_Farm/turtle (2).jpeg"
import u4 from "./Gellery/turtle_Farm/turtle (2).jpg"
import u5 from "./Gellery/turtle_Farm/turtle (3).jpg"
import u6 from "./Gellery/turtle_Farm/turtle (3).jpeg"
import u7 from "./Gellery/turtle_Farm/turtle (4).jpeg"
import u8 from "./Gellery/turtle_Farm/turtle (5).jpeg"
import u9 from "./Gellery/turtle_Farm/turtle (6).jpeg"
import u10 from "./Gellery/turtle_Farm/turtle (7).jpeg"
import u11 from "./Gellery/turtle_Farm/turtle (8).jpeg"

//Yala

import y1 from "./Gellery/yala/yala (1).jpeg"
import y2 from "./Gellery/yala/yala (1).jpg"
import y3 from "./Gellery/yala/yala (2).jpeg"
import y4 from "./Gellery/yala/yala (2).jpg"
import y5 from "./Gellery/yala/yala (3).jpeg"
import y6 from "./Gellery/yala/yala (3).jpg"
import y7 from "./Gellery/yala/yala (4).jpeg"
import y8 from "./Gellery/yala/yala (4).jpg"
import y9 from "./Gellery/yala/yala (5).jpeg"
import y10 from "./Gellery/yala/yala (5).jpg"
import y11 from "./Gellery/yala/yala (6).jpeg"
import y12 from "./Gellery/yala/yala (6).jpg"
import y13 from "./Gellery/yala/yala (7).jpg"
import y14 from "./Gellery/yala/yala (8).jpg"
import y15 from "./Gellery/yala/yala (26).jpg"
import y16 from "./Gellery/yala/yala (25).jpg"
import y17 from "./Gellery/yala/yala (24).jpg"
import y18 from "./Gellery/yala/yala (23).jpg"
import y19 from "./Gellery/yala/yala (22).jpg"
import y20 from "./Gellery/yala/yala (21).jpg"
import y21 from "./Gellery/yala/yala (20).jpg"
import y22 from "./Gellery/yala/yala (19).jpg"
import y23 from "./Gellery/yala/yala (18).jpg"
import y24 from "./Gellery/yala/yala (17).jpg"
import y25 from "./Gellery/yala/yala (16).jpg"
import y26 from "./Gellery/yala/yala (15).jpg"
import y27 from "./Gellery/yala/yala (14).jpg"
import y28 from "./Gellery/yala/yala (13).jpg"
import y29 from "./Gellery/yala/yala (12).jpg"
import y30 from "./Gellery/yala/yala (11).jpg"
import y31 from "./Gellery/yala/yala (10).jpg"
import y32 from "./Gellery/yala/yala (9).jpg"

//udawalawa
import x from "./Gellery/Udawalawa/uda (1).jpeg"
import x1 from "./Gellery/Udawalawa/uda (2).jpeg"
import x2 from "./Gellery/Udawalawa/uda (3).jpeg"
import x3 from "./Gellery/Udawalawa/uda (4).jpeg"
import x4 from "./Gellery/Udawalawa/uda (5).jpeg"

// whale

import z from "././Gellery/wells/g10.jpg"
import z1 from "././Gellery/wells/g33.jpg"

// silck

import si from "./Gellery/silick factory/WhatsApp Video 2025-07-14 at 7.45.17 PM.mp4"
import si1 from "./Gellery/silick factory/WhatsApp Video 2025-07-14 at 7.45.16 PM (1).mp4"
import si2 from "./Gellery/silick factory/WhatsApp Video 2025-07-14 at 7.45.16 PM.mp4"
import si3 from "./Gellery/silick factory/sil.jpg"

// memo


import v1 from "././Gellery/memp/memo (1).jpg";
import v3 from "././Gellery/memp/memo (2).jpg";
import v4 from "././Gellery/memp/memo (2).jpeg";
import v5 from "././Gellery/memp/memo (3).jpg";
import v6 from "././Gellery/memp/memo (3).jpeg";
import v7 from "././Gellery/memp/memo (4).jpg";
import v8 from "././Gellery/memp/memo (4).jpeg";
import v9 from "././Gellery/memp/memo (5).jpg";
import v10 from "././Gellery/memp/memo (5).jpeg";
import v11 from "././Gellery/memp/memo (6).jpg";
import v12 from "././Gellery/memp/memo (6).jpeg";
import v13 from "././Gellery/memp/memo (7).jpg";
import v14 from "././Gellery/memp/memo (7).jpeg";
import v15 from "././Gellery/memp/memo (8).jpg";
import v16 from "././Gellery/memp/memo (8).jpeg";
import v17 from "././Gellery/memp/memo (9).jpg";
import v18 from "././Gellery/memp/memo (9).jpeg";
import v19 from "././Gellery/memp/memo (10).jpg";
import v20 from "././Gellery/memp/memo (10).jpeg";
import v21 from "././Gellery/memp/memo (11).jpg";
import v22 from "././Gellery/memp/memo (11).jpeg";
import v23 from "././Gellery/memp/memo (12).jpg";
import v24 from "././Gellery/memp/memo (12).jpeg";
import v25 from "././Gellery/memp/memo (13).jpg";
import v26 from "././Gellery/memp/memo (13).jpeg";
import v27 from "././Gellery/memp/memo (14).jpg";
import v28 from "././Gellery/memp/memo (14).jpeg";
import v29 from "././Gellery/memp/memo (15).jpg";
import v30 from "././Gellery/memp/memo (15).jpeg";
import v31 from "././Gellery/memp/memo (16).jpg";
import v32 from "././Gellery/memp/memo (16).jpeg";
import v33 from "././Gellery/memp/memo (17).jpg";
import v34 from "././Gellery/memp/memo (17).jpeg";
import v35 from "././Gellery/memp/memo (18).jpg";
import v36 from "././Gellery/memp/memo (18).jpeg";
import v37 from "././Gellery/memp/memo (19).jpeg";
import v38 from "././Gellery/memp/memo (20).jpeg";




export const albums = [
    {
        id: 1,
        name: "Airport drop and pickup",
        cover: a,
        photos: [a, a1],
    },
    {
        id: 16,
        name: "Honey Beach",
        cover: r14,
        photos: [r23, r2, r3, r4, r5, r6, r7, r8, r9, r10,r1,
            r11, r12, r13, r14, r15, r16, r17, r18, r19, r20,
            r21, r22,  r24, r25, r26, r27, r28, r29, r30,
            r31, r32, r33, r34, r35, r36, r37, r38, r39, r40,
            r41, r42, r43, r44, r45, r46, r47, r48, r49, r50,
            r51, r52, r53, r54, r55, r56,r57],
    },
    {
        id: 17,
        name: "Madu Lagoon Tour",
        cover: t1,
        photos: [ t1, t2, t3,t4, t5, t6, t7, t8, t9, t10,
            t11, t12, t13, t14, t15, t16, t18, t19, t20,
            t21, t22, t24, t25, t26, t27, t28, t29, t30,
            t31, t32, t33, t34, t35, t36, t37, t38, t39, t40,
            t41, t42, t43, t44, t45, t46, t47, t48, t49, t50,
            t51, t52, t53, t54, t55, t56, t57, t58, t59, t60,
            t61, t62, t63, t64, t65, t66, t67, t68, t69, t70,
            t71, t72, t73, t74, t75, t76, t77, t78, t79,
            t81, t82, t83, t84, t85, t86, t87, t88, t89, t90,
            t91, t92, t93, t94, t95, t96, t97],
    },
    {
        id: 2,
        name: "Ambuluwawa Tower",
        cover: e,
        photos: [d, e],
    },
    {
        id: 3,
        name: "Bawa Garden",
        cover: b,
        photos: [
            b, b1, b2, b3, b4, b5, b7, b8, b9, b10, b11, b12, b13, b14,
            b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29,
            b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44,
            b45, b46, b47, b48, b49, b50, b51, b52, b53, b54, b55, b56, b57, b58, b59,
            b60,c1 , c2, c3, c4,c5, b61, b62, b63, b64, b65, b66, b67,b68,b69,b70,b71,b72
        ],

    },
    {
        id: 4,
        name: "Brief Garden",
        cover: c6,
        photos: [c6,c7,c8,c9,c10,c11,c12,c13,c14,c15,c16,c17,c18,c19,c20,c21,c22,c23,c24,c25],
    },

    {
        id: 4,
        name: "Ella",
        cover: d1,
        photos: [d1 , d2, d3, d4,d5,d6,d7,d8,dd1,dd2,dd3,dd4,],

    },
    {
        id: 5,
        name: "Galle",
        cover: e12,
        photos: [ee,e1 , e2, e3, e4,e5,e6,e7,e8,e9,e10,e11,e12,e13,e14,e15,e16,e17,e18],
    },
    {
        id: 6,
        name: "Gems Museum",
        cover: f,
        photos: [f],

    },
    {
        id: 7,
        name: "God Temple & buddha statue",
        cover: g,
        photos: [g,g1,g2,g3,g4,g5,g6],
    },
    {
        id: 8,
        name: "Sigiri & Dambulla",
        cover: h9,
        photos: [h,h1,h2,h3,h4,h5,h6,h7,h8,h9,h10,h11,h12,h13,h14,h15,h16,h17,h18,h19,h20,h21,h22,h23,h24,h25,h26,h27,h28,h29,h30,h31,h32,h33,h34,h35,h36,h37],
    },
    {
        id: 9,
        name: "Shiva Kovil",
        cover: i,
        photos: [i,i1],
    },
    {
        id: 10,
        name: "Kande Viharaya",
        cover: j,
        photos: [j,j1,j2,j3],
    },
    {
        id: 10,
        name: "Kandy",
        cover: hh1,
        photos: [hh1],
    },
    {
        id: 11,
        name: "Ceylone SPA",
        cover: k,
        photos: [k],
    },
    {
        id: 12,
        name: "Pinnawala Elephant orphanage",
        cover: l,
        photos: [l,hh],
    },
    {
        id: 13,
        name: "Moonstone Mine",
        cover: m,
        photos: [m,m1],
    },
    {
        id: 14,
        name: "Tea Land & WaterFall",
        cover: p,
        photos: [p,p1,p2,p3,p4,p5,p6,p7,p8,p9,p10,p11,p12],
    },
    {
        id: 15,
        name: "Karandeniya Temple",
        cover: q3,
        photos: [q,q1,q2,q3,q4,q5,q6,q7,q8,q9,q10,q11,q12,q13,q14,q15,q16,q17,q18,q19,q20,q21],
    },

    {
        id: 17,
        name: "Hikkaduwa Turtle Beach",
        cover: s,
        photos: [s,s1,s2,s3],
    },
    {
        id: 18,
        name: "Turtle Farm",
        cover: u2,
        photos: [u1,u2,u3,u4,u5,u6,u7,u8,u9,u10,u11],
    },

    {
        id: 20,
        name: "Silk Factory",
        cover: si3,
        videos: [si,si1,si2],
        photos: [si3]
    },

    {
        id: 19,
        name: "Yala National Park",
        cover: y2,
        photos: [y1,y2,y3,y4,y5,y6,y7,y8,y9,y10,y11,y12,y13,y14,y15,y16,y17,y18,y19,y20,y21,y22,y23,y24,y25,y26,y27,y28,y29,y30,y31,y32],
    },
    {
        id: 20,
        name: "Udawalawe National Park",
        cover: x,
        photos: [x,x1,x2,x3,x4],
    },
    {
        id: 20,
        name: "Whale & dolphin watching Mirissa",
        cover: z,
        photos: [z,z1],
    },
    {
        id: 20,
        name: "Memory",
        cover: v1,
        photos: [v1, v3, v4, v5, v6, v7, v8, v9, v10,
            v11, v12, v13, v14, v15, v16, v17, v18, v19, v20,
            v21, v22, v23, v24, v25, v26, v27, v28, v29, v30,
            v31, v32, v33, v34, v35, v36, v37,v38],
    },
];
